import { PageIntro } from '@landsbankinn/shared/components/templates/intro/PageIntro';
import { ArrowButton, Segment } from '@landsbankinn/ui';
import type { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';

interface IProps {
  statusCode?: number;
}

const ErrorPage: NextPage<IProps> = ({ statusCode }) => {
  return (
    <Segment
      paddingBottom={400}
      paddingTop={200}
      style={{ minHeight: 'calc(100vh - 500px)' }}
    >
      <Head>
        <title>404 - Landsbankinn</title>
      </Head>
      <PageIntro
        title="Vefsíðan eða skjalið fannst ekki"
        copySize={true}
        copy={
          <>
            <p>
              Ástæður geta verið eftirfarandi: Slóðin á síðuna er ekki til,
              villa var gerð við innslátt eða tengillinn sem vísaði á síðuna er
              rangur. Síðan hefur verið fjarlægð og er því ekki lengur til á
              vefþjóni. Síðan er ekki aðgengileg þessa stundina
            </p>
            <br />
            <p>
              Ef þú finnur ekki efnið sem þú leitar að, þá er hægt að fylla út
              fyrirspurnarform, senda tölvupóst á netfangið{' '}
              <a
                href="mailto:landsbankinn@landsbankinn.is"
                style={{ textDecoration: 'underline' }}
              >
                landsbankinn@landsbankinn.is
              </a>{' '}
              með upplýsingum um hvaða síðu/skjal verið var að reyna að
              skoða/finna, eða hringja í síma:{' '}
              <a href="tel:4104000" style={{ fontWeight: 'bold' }}>
                410 4000
              </a>
              .
            </p>
          </>
        }
        action={
          <ArrowButton
            href="mailto:landsbankinn@landsbanki.is"
            title="landsbankinn@landsbankinn.is"
            isSmall
          />
        }
      />
    </Segment>
  );
};

ErrorPage.getInitialProps = async ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;

  return { statusCode };
};

export default ErrorPage;
